import { render, staticRenderFns } from "./facet.vue?vue&type=template&id=41982a67&scoped=true"
import script from "./facet.vue?vue&type=script&lang=js"
export * from "./facet.vue?vue&type=script&lang=js"
import style0 from "./facet.vue?vue&type=style&index=0&id=41982a67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41982a67",
  null
  
)

export default component.exports